module.exports = __webpack_public_path__ + "fonts/Roboto-400.3e1af3ef.ttf";